var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.repair
        ? _c(
            "div",
            [
              _c(
                "cms-heading",
                { attrs: { title: _vm.pageTitle } },
                [
                  _c(
                    "cms-button",
                    {
                      attrs: {
                        icon: "magicon-pencil",
                        to: {
                          name: "repair-edit",
                          params: { id: _vm.repair.id },
                        },
                      },
                    },
                    [_vm._v("Wijzigen")]
                  ),
                  _c(
                    "cms-button",
                    {
                      attrs: { icon: "magicon-jump-right-up" },
                      on: { click: _vm.exportRepair },
                    },
                    [_vm._v("Exporteren (CSV)")]
                  ),
                ],
                1
              ),
              _c("cms-view-panel", [
                _c("tr", [
                  _c("td", { staticClass: "key" }, [_vm._v("Referentie")]),
                  _c("td", [_vm._v(_vm._s(_vm.repair.reference))]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "key" }, [_vm._v("Startdatum")]),
                  _c("td", [
                    _vm._v(_vm._s(_vm._f("date")(_vm.repair.startDate, "LL"))),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "key" }, [_vm._v("Einddatum")]),
                  _c("td", [
                    _vm._v(_vm._s(_vm._f("date")(_vm.repair.endDate, "LL"))),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "key" }, [_vm._v("Aantal loggers")]),
                  _c("td", [_vm._v(_vm._s(_vm.repair.loggers.itemCount))]),
                ]),
              ]),
              _c(
                "cms-heading",
                { attrs: { title: "Loggers", level: "2" } },
                [
                  _c(
                    "cms-button",
                    {
                      attrs: {
                        color: "highlight-1",
                        icon: "magicon-ok",
                        disabled: _vm.selectedLoggers.length == 0,
                      },
                      on: { click: _vm.makeSelection },
                    },
                    [
                      _vm._v(
                        "Selectie maken (" +
                          _vm._s(_vm.selectedLoggers.length) +
                          ")"
                      ),
                    ]
                  ),
                  _c(
                    "cms-button",
                    {
                      attrs: {
                        color: "default-dark",
                        icon: "magicon-close",
                        disabled: _vm.selectedLoggers.length == 0,
                      },
                      on: { click: _vm.resetSelection },
                    },
                    [_vm._v("Reset selectie")]
                  ),
                ],
                1
              ),
              _c(
                "cms-table-panel",
                {
                  directives: [
                    {
                      name: "spinner",
                      rawName: "v-spinner",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    placeholder:
                      !_vm.repair.loggers.items ||
                      !_vm.repair.loggers.items.length,
                    "show-count": "true",
                    clickable: "true",
                  },
                },
                [
                  _c(
                    "cms-table-header",
                    [
                      _c(
                        "cms-th",
                        {
                          attrs: { field: "serialNumber" },
                          model: {
                            value: _vm.loggersSort,
                            callback: function ($$v) {
                              _vm.loggersSort = $$v
                            },
                            expression: "loggersSort",
                          },
                        },
                        [_vm._v("Serienummer")]
                      ),
                      _c(
                        "cms-th",
                        {
                          attrs: { field: "typeId" },
                          model: {
                            value: _vm.loggersSort,
                            callback: function ($$v) {
                              _vm.loggersSort = $$v
                            },
                            expression: "loggersSort",
                          },
                        },
                        [_vm._v("Type")]
                      ),
                      _c(
                        "cms-th",
                        {
                          attrs: { field: "state" },
                          model: {
                            value: _vm.loggersSort,
                            callback: function ($$v) {
                              _vm.loggersSort = $$v
                            },
                            expression: "loggersSort",
                          },
                        },
                        [_vm._v("Status")]
                      ),
                      _c(
                        "cms-th",
                        {
                          attrs: { field: "owner" },
                          model: {
                            value: _vm.loggersSort,
                            callback: function ($$v) {
                              _vm.loggersSort = $$v
                            },
                            expression: "loggersSort",
                          },
                        },
                        [_vm._v("Eigendom")]
                      ),
                      _c("cms-th", [_vm._v("Opmerkingen")]),
                      _c(
                        "cms-th",
                        { staticStyle: { width: "40px" } },
                        [
                          _c("cms-checkbox", {
                            attrs: {
                              checked:
                                _vm.repair.loggers.items &&
                                _vm.selectedLoggers.length ==
                                  _vm.repair.loggers.items.length,
                            },
                            on: { input: _vm.toggleSelection },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.repair.loggers.items, function (logger) {
                    return _c(
                      "tr",
                      {
                        class: { selected: _vm.isSelected(logger) },
                        on: {
                          click: function ($event) {
                            return _vm.showLogger(logger)
                          },
                        },
                      },
                      [
                        _c("td", [_vm._v(_vm._s(logger.serialNumber))]),
                        _c("td", [_vm._v(_vm._s(logger.type.title))]),
                        _c(
                          "td",
                          [
                            _c("cms-text-label", {
                              attrs: {
                                title: _vm._f("loggerState")(logger.state),
                                color: _vm._f("loggerStateColor")(logger.state),
                              },
                            }),
                          ],
                          1
                        ),
                        _c("td", [_vm._v(_vm._s(logger.owner))]),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              logger.latestMutation
                                ? logger.latestMutation.comments
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "td",
                          {
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [
                            _c("cms-checkbox", {
                              attrs: { checked: _vm.isSelected(logger) },
                              on: {
                                input: function ($event) {
                                  return _vm.updateSelection(
                                    logger,
                                    arguments[0]
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }